import styled from "styled-components";
import { style as styleConfig } from "config";
const Form = styled.form `
  width: ${(p) => (p.fullWidth ? "100%" : "90%")};

  @media (${styleConfig.media.desktop}) {
    width: ${(p) => (p.fullWidth ? "100%" : "50%")};
    max-width: 780px;
  }
`;
export default Form;
